import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlusIconComponent } from './plus-icon.component';

@NgModule({
    declarations: [PlusIconComponent],
    imports: [CommonModule],
    exports: [PlusIconComponent],
})
export class PlusIconModule {}
